import { 
  removeFineUser,
  checkFineUser,
  saveFineUser,
  getFineUser,
} 
from './security.js'
import {
  createIframe,
  findIframe,
  sendMessageToIframe,
  removeIframe
} from './iframe.js'

// 创建iframe，登录帆软系统
export const doSubmit = (callback, params,user) => {
  const {iframeId} = params
  if(!findIframe(iframeId)){
    createIframe(params,callback,user)
  }else{
    callback()
  }
  return true
}
export default {
  doSubmit,
  saveFineUser,
  checkFineUser,
  removeFineUser,
  getFineUser,
  print,
  findIframe,
  sendMessageToIframe,
  removeIframe
}
